/*
 * @Author: wjl
 * @Date: 2020-04-21 13:45:56
 * @LastEditors: wjl
 * @LastEditTime: 2020-09-04 11:56:53
 * @FilePath: \appOfficial\src\utils\en.js
 */
module.exports = {
  bottomList: {
    0: { title: "Follow us", two: "Wechat", thre: "Sina microblog " },
    1: {
      title: "Join us",
      two: "Social recruitment",
      thre: "Campus recruitment",
      for: "Global Recruitment",
    },
    2: {
      title: "Contact Us",
      two: "Contact Us",
      thre: "Cooperation negotiation",
    },
  },
  bottomTxt: {
    0: "Copyright © 1998-2017 jinlin. All Rights Reserved. Copyright of Jinling Technology Co., Ltd.",
    1: {
      0: "Friendship link:",
      1: "JINLING",
      2: "CAUA",
      3: "CNCAPRC",
      4: "Calendar fun APP download",
    },
    2: { 0: "Record No.：", 1: "Guangdong ICP No. 19021271" },
  },
  modelList: [
    {
      title: "Jinling Wechat Service Account",
      img: require("@/images/wechat.jpg"),
    },
    {
      title: "Scan code add customer service WeChat",
      img: require("@/images/service.jpeg"),
    },
    {
      title: "Business Cooperation",
      img: require("@/images/cooperate.png"),
      number: "0755-2692 0484",
    },
  ],
};
